var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("header-view", {
                staticClass: "text-uppercase",
                attrs: { title: _vm.$t("message.policies.title"), icon: "" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c("b-col", [
            _c("p", [
              _vm._v(
                "Mit diesen Hinweisen informieren wir Sie über die Verarbeitung Ihrer personenbezogenen Daten durch die\n        CodeCamp:N GmbH und die Ihnen nach dem Datenschutzrecht zustehenden Rechte. Verantwortliche Stelle im Sinne\n        der Datenschutzgesetze, insbesondere der EU-Datenschutzgrundverordnung (DS-GVO), ist:"
              )
            ]),
            _vm._v(" "),
            _c("h5", [_vm._v("I. Name und Anschrift des Verantwortlichen")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Der Verantwortliche im Sinne der Datenschutz-Grundverordnung und anderer nationaler Datenschutzgesetze der\n        Mitgliedsstaaten sowie sonstiger datenschutzrechtlicher Bestimmungen ist die:"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("\n        CodeCamp:N GmbH "),
              _c("br"),
              _vm._v("\n        Solgerstr. 18 "),
              _c("br"),
              _vm._v("\n        90429 Nürnberg "),
              _c("br"),
              _vm._v("\n        Telefon: +49 911 2744 8523 "),
              _c("br"),
              _vm._v("\n        E-Mail: info@codecamp-n.com\n      ")
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h5", [_vm._v("II. Kontaktdaten des Datenschutzbeauftragten")]),
            _vm._v(" "),
            _c("p", [
              _vm._v("Unseren Datenschutzbeauftragten erreichen Sie unter:")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("\n        Frau Sabine Sobola "),
              _c("br"),
              _vm._v("\n        LiiDU GmbH "),
              _c("br"),
              _vm._v("\n        Neupfarrplatz 10 "),
              _c("br"),
              _vm._v("\n        93047 Regensburg "),
              _c("br"),
              _vm._v("\n        Deutschland "),
              _c("br"),
              _vm._v("\n        Telefon: 0941 46392460 "),
              _c("br"),
              _vm._v("\n        Mail: info@liidu.de\n      ")
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h5", [_vm._v("III. Ihre Betroffenenrechte")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Sie können unter der oben genannten Adresse Auskunft über die zu Ihrer Person gespeicherten Daten verlangen.\n        Darüber hinaus können Sie unter bestimmten Voraussetzungen die Berichtigung oder die Löschung Ihrer Daten\n        verlangen. Ihnen kann weiterhin ein Recht auf Einschränkung der Verarbeitung Ihrer Daten sowie ein Recht auf\n        Herausgabe der von Ihnen bereitgestellten Daten in einem strukturierten, gängigen und maschinenlesbaren\n        Format zustehen."
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h5", [_vm._v("IV. Widerspruchsrecht")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Sie haben das Recht, einer Verarbeitung Ihrer personenbezogenen Daten zu Zwecken der Direktwerbung zu\n        widersprechen. Verarbeiten wir Ihre Daten zur Wahrung berechtigter Interessen, können Sie dieser Verarbeitung\n        widersprechen, wenn sich aus Ihrer besonderen Situation Gründe ergeben, die gegen die Datenverarbeitung\n        sprechen.\n      "
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h5", [_vm._v("V. Recht auf Datenübertragbarkeit")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Ihnen steht das Recht zu, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags\n        automatisiert verarbeiten, an sich oder an Dritte aushändigen zu lassen. Die Bereitstellung erfolgt in einem\n        maschinenlesbaren Format. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen\n        verlangen, erfolgt dies nur, soweit es technisch machbar ist.\n      "
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h5", [_vm._v("VI. Recht auf Löschung")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Sie haben das Recht, von dem Verantwortlichen zu verlangen, dass die Sie betreffenden personenbezogenen Daten\n        unverzüglich gelöscht werden. Sofern Sie eine endgültige Löschung Ihres angelegten Accounts und somit auch die\n        Löschung Ihrer personenbezogenen Daten veranlassen möchten, stehen Ihnen zwei Möglichkeiten zur Verfügung.\n        Zum einen können Sie jederzeit eine E-Mail an info@codecamp-n.com schicken und die Löschung Ihrer Daten\n        veranlassen. Dabei wird Ihr Account und die damit verbundenen personenbezogenen Daten durch einen\n        Administrator gelöscht\n      "
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h5", [_vm._v("VII. Beschwerderecht")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Sie haben die Möglichkeit, sich mit einer Beschwerde an uns oder den oben genannten (o. g.)\n        Datenschutzbeauftragten unter den o. g. Kontaktdaten oder an eine Datenschutzaufsichtsbehörde zu wenden.\n        Die für uns zuständige Datenschutzaufsichtsbehörde ist:\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [_vm._v("Aufsichtsbehörde")]),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "\n        Bayerisches Landesamt für Datenschutzaufsicht "
              ),
              _c("br"),
              _vm._v("\n        Promenade 18, 91522 Ansbach "),
              _c("br"),
              _vm._v("\n        Postanschrift: Postfach 606, 91511 Ansbach "),
              _c("br"),
              _vm._v("\n        Telefon: 0981/180093-0 "),
              _c("br"),
              _vm._v("\n        Telefax: 0981/180093-99 "),
              _c("br"),
              _vm._v("\n        E-Mail: poststelle@lda.bayern.de "),
              _c("br"),
              _vm._v("\n        Homepage: https://www.lda.bayern.de "),
              _c("br")
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h5", [
              _vm._v(
                "VIII. Zwecke der Datenverarbeitung durch die verantwortliche Stelle und Dritte"
              )
            ]),
            _vm._v(" "),
            _c("p"),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Wir verarbeiten Ihre personenbezogenen Daten unter Beachtung der EU-Datenschutz-Grundverordnung (DS-GVO).\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Meine-vertraege.net ist ein digitaler Vertragsmanager der es Benutzern erlaubt, seine kompletten\n        Vertragsverhältnisse zu erfassen und aufzulisten. Der digitale Vertragsmanager wird als\n        Assistancedienstleistung der Bestattungsvorsorgeversicherung von der NÜRNBERGER VERSICHERUNG in\n        Kooperation mit dem Kuratorium Deutsche Bestattungskultur angeboten.\n      "
              )
            ]),
            _vm._v(
              "\n      Sie können sich auf unserer Webseite durch Angaben von Name, Vorname, E-Mail-Adresse, Geburtsdatum,\n      Versicherungsnummer und einem Passwort registrieren und einen Account einrichten. Rechtsgrundlage hierfür\n      ist der mit Ihnen geschlossene Vertrag nach Art. 6 Abs. 1 S. 1 lit. b) DS-GVO.\n      "
            ),
            _c("p", [
              _vm._v(
                "\n        Des Weiteren kann der Kontoinhaber Kontaktpersonen bestimmen, welche nach seinem Ableben Einsicht in die ihnen\n        zugeordneten Verträge gewährt bekommen. Rechtsgrundlage hierfür ist Ihre Einwilligung nach\n        Art. 6 Abs. 1 S. 1 lit. a) DS-GVO.\n      "
              )
            ]),
            _vm._v(
              "\n      Um eine Darstellung unserer Webseite zu gewährleisten und unsere Anwendung stetig weiterzuentwickeln,\n      verwenden auf unserer Website Cookies. Nähere Informationen zum Einsatz und der Rechtsgrundlage finden\n      Sie im Abschnitt „Cookies“.\n      "
            ),
            _c("p", [
              _vm._v(
                "\n        Des Weiteren kann es sein, dass es uns gesetzlich vorgeschrieben ist, Ihre Daten zu verarbeiten. Diese\n        Verarbeitung, ist dann zur Erfüllung einer gesetzlichen Verpflichtung erforderlich (Art. 6 Abs. 1 S. 1 lit. c)\n        DS-GVO). Dies ist zum Beispiel in solchen Situationen der Fall, wenn wir durch Gesetz bestimmte\n        Aufbewahrungsfristen haben.\n      "
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h5", [_vm._v("IX. Amazon Web Services")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Wir hosten unsere Systeme bei Amazon Web Services, Inc., 410 Terry Avenue North, Seattle WA 98109, USA („AWS“)\n        auf der Rechtsgrundlage Vertragserfüllung nach Art. 6 Abs. 1 S.1 lit. b) DS-GVO. Die Systeme werden in der\n        EU Region Irland des AWS Netzwerks gehostet. Entsprechend Art. 28 DS-GVO haben wir einen\n        Auftragsdatenverarbeitungsvertrag (Data-Processing-Agreement) mit Amazon Web Services abgeschlossen. Dabei\n        handelt es sich um einen Vertrag, in dem sich AWS unter anderem dazu verpflichtet, die Daten unserer Nutzer\n        zu schützen, entsprechend den festgehaltenen Datenschutzbestimmungen in unserem Auftrag zu verarbeiten und\n        insbesondere nicht an Dritte weiterzugeben. Nähere Informationen hierzu finden Sie in der\n        "
              ),
              _c(
                "a",
                {
                  attrs: { href: "https://aws.amazon.com/de/privacy/?nc1=f_pr" }
                },
                [_vm._v("Datenschutzerklärung von AWS")]
              ),
              _vm._v(".\n      ")
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h5", [_vm._v("X. Speicherdauer")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Wir halten uns an die Grundsätze der Datenvermeidung und Datensparsamkeit. Wir speichern Ihre\n        personenbezogenen Daten daher nur so lange, wie dies zur Erreichung der hier genannten Zwecke erforderlich ist\n        oder wie es die vom Gesetzgeber vorgesehenen vielfältigen Speicherfristen vorsehen. Nach Fortfall des\n        jeweiligen Zweckes bzw. Ablauf dieser Fristen werden die entsprechenden Daten routinemäßig und entsprechend\n        den gesetzlichen Vorschriften gesperrt oder gelöscht. Ihnen steht es frei, die bei der Registrierung\n        angegebenen Daten jederzeit vollständig aus der Datenbank löschen zu lassen. Rechtsgrundlage für die\n        Aufbewahrung der Unterlagen für die Dauer der gesetzlichen Aufbewahrungsfristen ist die Erfüllung gesetzlicher\n        Vorgaben nach Art. 6 Abs. 1 S. 1 lit. c) DS-GVO.\n      "
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h5", [_vm._v("XI.TLS-Verschlüsselung")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Um die Sicherheit Ihrer Daten bei der Übertragung zu schützen, verwenden wir dem aktuellen Stand der Technik\n        entsprechende Verschlüsselungsverfahren (z.B. TLS) über HTTPS.\n      "
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h5", [_vm._v("XII. Kontaktformular")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Treten Sie bzgl. Fragen jeglicher Art per E-Mail mit uns in Kontakt, erteilen Sie uns zum Zwecke der\n        Kontaktaufnahme Ihre freiwillige Einwilligung nach Art. 6 Abs. 1 S. 1 lit. a) DS-GVO. Hierfür ist die Angabe\n        einer validen E-Mail-Adresse erforderlich. Diese dient der Zuordnung der Anfrage und der anschließenden\n        Beantwortung derselben. Die Angabe weiterer Daten ist optional. Die von Ihnen gemachten Angaben werden zum\n        Zwecke der Bearbeitung der Anfrage sowie für mögliche Anschlussfragen gespeichert. Nach Erledigung der von\n        Ihnen gestellten Anfrage werden personenbezogene Daten automatisch gelöscht.\n      "
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h5", [_vm._v("XIII. Verwendung von Google Maps")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Auf unserer Website verwenden wir Google Maps (API) von Google Ireland Limited, Gordon House, 4 Barrow St,\n        Dublin, D04 E5W5, Irland (“Google”). Google Maps ist ein Webdienst zur Darstellung von interaktiven\n        (Land-)Karten, um geographische Informationen visuell darzustellen. Über die Nutzung dieses Dienstes wird\n        Ihnen unser Standort angezeigt und eine etwaige Anfahrt erleichtert.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Bereits beim Aufrufen derjenigen Unterseiten, in die die Karte von Google Maps eingebunden ist, werden\n        Informationen über Ihre Nutzung unserer Website (wie z.B. Ihre IP-Adresse) an Server von Google übertragen\n        und dort gespeichert, hierbei kann es auch zu einer Übermittlung an die Server der Google LLC. in den USA\n        kommen. Dies erfolgt unabhängig davon, ob Google ein Nutzerkonto bereitstellt, über das Sie eingeloggt sind\n        oder ob ein Nutzerkonto besteht. Wenn Sie bei Google eingeloggt sind, werden Ihre Daten direkt Ihrem Konto\n        zugeordnet. Wenn Sie die Zuordnung mit Ihrem Profil bei Google nicht wünschen, müssen Sie sich vor Aktivierung\n        des Buttons ausloggen. Google speichert Ihre Daten (selbst für nicht eingeloggte Nutzer) als Nutzungsprofile\n        und wertet diese aus. Die Erhebung, Speicherung und die Auswertung erfolgen gemäß Art. 6 Abs. 1 S. 1 lit. a)\n        DS-GVO auf Basis ihrer Einwilligung.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Wenn Sie mit der künftigen Übermittlung Ihrer Daten an Google im Rahmen der Nutzung von Google Maps nicht\n        einverstanden sind, besteht auch die Möglichkeit, den Webdienst von Google Maps vollständig zu deaktivieren,\n        indem Sie die Anwendung JavaScript in Ihrem Browser ausschalten. Google Maps und damit auch die Kartenanzeige\n        auf dieser Internetseite kann dann nicht genutzt werden.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Die Nutzungsbedingungen von Google können Sie unter\n        "
              ),
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "https://www.google.de/intl/de/policies/terms/regional.html"
                  }
                },
                [
                  _vm._v(
                    "https://www.google.de/intl/de/policies/terms/regional.html"
                  )
                ]
              ),
              _vm._v(
                "\n        einsehen, die zusätzlichen Nutzungsbedingungen für Google Maps finden Sie unter\n        "
              ),
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "https://www.google.com/intl/de_US/help/terms_maps.html"
                  }
                },
                [
                  _vm._v(
                    "https://www.google.com/intl/de_US/help/terms_maps.html"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h5", [_vm._v("XIV. Eingebettete YouTube-Videos")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Auf einigen unserer Webseiten betten wir Youtube-Videos ein. Betreiber der entsprechenden Plugins ist die\n        YouTube, LLC, 901 Cherry Ave., San Bruno, CA 94066, USA. Wenn Sie eine Seite mit dem YouTube-Plugin besuchen,\n        wird eine Verbindung zu Servern von Youtube hergestellt. Dabei wird Youtube mitgeteilt, welche Seiten Sie\n        besuchen. Wenn Sie in Ihrem Youtube-Account eingeloggt sind, kann Youtube Ihr Surfverhalten Ihnen persönlich\n        zuzuordnen. Dies verhindern Sie, indem Sie sich vorher aus Ihrem Youtube-Account ausloggen.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Wird ein Youtube-Video gestartet, setzt der Anbieter Cookies ein, die Hinweise über das Nutzerverhalten sammeln.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Wer das Speichern von Cookies für das Google-Ad-Programm deaktiviert hat, wird auch beim Anschauen von\n        Youtube-Videos mit keinen solchen Cookies rechnen müssen. Youtube legt aber auch in anderen Cookies\n        nicht-personenbezogene Nutzungsinformationen ab. Möchten Sie dies verhindern, so müssen Sie das Speichern\n        von Cookies im Browser blockieren.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Die Nutzung von YouTube erfolgt auf Grundlage von Art. 6 Abs. 1 S. 1 lit. a) DS-GVO; die Einwilligung ist\n        jederzeit widerrufbar.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                '\n        Weitere Informationen zum Datenschutz bei „Youtube" finden Sie in der Datenschutzerklärung des Anbieters unter:\n        '
              ),
              _c(
                "a",
                {
                  attrs: { href: "https://policies.google.com/privacy?hl=de" }
                },
                [_vm._v("https://policies.google.com/privacy?hl=de")]
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h5", [_vm._v("XV. Änderung unserer Datenschutzbestimmungen")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen\n        Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen, z.B.\n        bei der Einführung neuer Services. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung. Die\n        aktuelle Datenschutzerklärung ist auf dem Stand des 14.07.2021.\n      "
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h5", [_vm._v("XVI. Fragen zum Datenschutz")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Wenn Sie Fragen zum Datenschutz haben, schreiben Sie uns bitte eine E-Mail an info@codecamp-n.com oder wenden\n        Sie sich direkt an den von uns bestellten Datenschutzbeauftragten unter den oben genannten Kontaktdaten.\n      "
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b4d18d5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4d18d5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/Policies.vue
// module id = PhFZ
// module chunks = 1